import Swiper from 'swiper';

// Hero Slider
const heroSlider = document.querySelector('.js-hero-slider'); // Max one per page
if (heroSlider) {
	const heroSliderOptions = {
		speed: 600,
		effect: 'fade',
		watchOverflow: true,
		//enable autoplay
		autoplay: {
			delay: 5000,
		},
		loop: true,
		navigation: {
			nextEl: heroSlider.querySelector('.js-slider-button-next'),
			prevEl: heroSlider.querySelector('.js-slider-button-prev'),
		},
		pagination: {
			el: heroSlider.querySelector('.js-pagination-wrapper'),
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return current;
			},
		},
		on: {
			init: () => {
				if (heroSlider.querySelectorAll('.slide').length > 1) {
					heroSlider.classList.add('slider-init');
				}
			},
		},
	};
	new Swiper(heroSlider, heroSliderOptions);
}

// Homepage weddings slider
const weddingsSlider = document.querySelector('.js-weddings-slider');
if (weddingsSlider) {
	
	const weddingsSliderOptions = {		
		direction: 'horizontal',
		effect: 'slide',
		speed: 1200,
		initialSlide: 1,
		slideToClickedSlide: true,
		centeredSlides: true,
		preventInteractionOnTransition: true,
		grabCursor: true,
		//longSwipes: false,
		//shortSwipes: false,
		//slidesPerView: 2,
		//spaceBetween: 80,		
		breakpointsInverse: true,
		slidesPerView: 1.2,
		spaceBetween: 15,		
		navigation: {
			nextEl: weddingsSlider.querySelector('.js-slider-button-next'),
			prevEl: weddingsSlider.querySelector('.js-slider-button-prev'),
		},
		breakpoints: {
			// when window width is => 480px etc
			480: {				
				spaceBetween: 20,
			},
			600: {				
				spaceBetween: 15,
				slidesPerView: 1.4,
			},
			900: {				
				spaceBetween: 40,
				slidesPerView: 1.6,
			},
			1200: { // aftee 1200px we show arrows
				spaceBetween: 50,
				slidesPerView: 1.8,
				followFinger: false,
			},
			1600: {
				spaceBetween: 80,
				slidesPerView: 2,
				followFinger: false,
			}
		}
		/*breakpoints: {
			// when window width is <= 480px etc
			480: {				
				spaceBetween: 15,
				slidesPerView: 1.2,
			},
			600: {				
				spaceBetween: 20,
				slidesPerView: 1.2,
			},
			900: {				
				spaceBetween: 15,
				slidesPerView: 1.4,
			},
			1200: {
				grabCursor: true,
				longSwipes: true,
				shortSwipes: true,
				followFinger: true,
				spaceBetween: 40,
				slidesPerView: 1.6,
			},
			1600: {
				spaceBetween: 50,
				slidesPerView: 1.8,
			}
		}*/
	};
	new Swiper(weddingsSlider, weddingsSliderOptions);
}
// Homepage testimonials slider
const testimonialsSlider = document.querySelector('.js-testimonials-slider');
if (testimonialsSlider) {
	const testimonialsSliderOptions = {
		speed: 600,
		effect: 'fade',
		crossFade: true,
		followFinger: false,
		pagination: {
			el: testimonialsSlider.querySelector('.slider-pagination'),
			type: 'bullets',
			clickable: true,
			bulletClass: 'pagination-bullet',
			bulletActiveClass: 'pagination-bullet-active'
		},
		navigation: {
			nextEl: testimonialsSlider.querySelector('.js-slider-button-next'),
			prevEl: testimonialsSlider.querySelector('.js-slider-button-prev'),
		},
	};
	new Swiper(testimonialsSlider, testimonialsSliderOptions);
}